import React from 'react';

import styles from './Delimiter.module.scss';
import cn from "classnames";

export function Delimiter(props) {
  return <div style={props.style} className={cn(styles.delimiter, styles.white, {[styles.dark]: props.dark})}/>;
}
